var _desc, _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "37px",
    viewBox: "0 0 29 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "location pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,31 L2.35154062,18.8276836 C-0.783846872,14.6242938 -0.783846872,8.80084746 2.35154062,4.59745763 C4.54201681,1.66384181 7.89215686,0 11.5,0 C15.1078431,0 18.4579832,1.66384181 20.6484594,4.59745763 C23.7838469,8.80084746 23.7838469,14.6242938 20.6484594,18.8276836 L11.5,31 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.0%",
    y: "-9.7%",
    width: "152.2%",
    height: "138.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.258928571   0 0 0 0 0.217633224   0 0 0 0 0.217633224  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Location---pin-point",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location---added-address-copy",
    transform: "translate(-195.000000, -307.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-pin",
    transform: "translate(195.000000, 307.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,27 L3.94257703,17.1836158 C1.35247432,13.7937853 1.35247432,9.09745763 3.94257703,5.70762712 C5.75210084,3.34180791 8.51960784,2 11.5,2 C14.4803922,2 17.2478992,3.34180791 19.057423,5.70762712 C21.6475257,9.09745763 21.6475257,13.7937853 19.057423,17.1836158 L11.5,27 Z",
    id: "Shape",
    fill: "#FF00A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,7 C9.25,7 7,9.25 7,12 C7,14.75 9.25,17 12,17 C14.75,17 17,14.75 17,12 C17,9.25 14.75,7 12,7 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.d29c6cf059b62e06e2733f16ea509f3c.svg";
export { ForwardRef as ReactComponent };